export default class Captcha {

    importScript() {
        const script = document.createElement("script");
        const body = document.body
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RCAPTCHA_CLIENT_ID}`;
        script.async = true;
        body.appendChild(script);
    }

    async generateToken(action) {
        /* eslint-disable */
        return await grecaptcha.enterprise.execute(`${process.env.REACT_APP_RCAPTCHA_CLIENT_ID}`, { action: action });
    }
}


export const RECAPTCHA_ACTIONS = {
    PAYMENT_ADD: 'payment_add',
    LOGIN: 'login',
    CART_ADD: 'cart_add',
    CHECKOUT: 'checkout',
    PASSWORD_RESET: 'password_reset'
}